module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Huddersfield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Huddersfield.png
// module id = 2083
// module chunks = 4